/**
 * Helper class for Api routes
 */
export default class Routes {
    /**
     * @description Populating variables in string with data
     * Ex. Setting parameter Id's for api-route/endpoint (Basic string interpolation)
     * @param {*} route
     * @property {object} parameters
     * @returns {string} new route
     */
    setRouteParameters(route, parameters) {
        if(parameters !== null){
            let tempLiterals = route.match(/\{(.*?)\}/g);
            tempLiterals.forEach((tempLiterals) => {
                let substitution = tempLiterals.substring(1, tempLiterals.length - 1);
                route = parameters[substitution]
                    ? route.replace(tempLiterals, parameters[substitution])
                    : null;
            });
        }
        
        return route;
    }
}
